<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <div :id="mapType" class="pa-4" style="width: 100%;height: 800px;"></div>
      <div id="popup" class="ol-popup">
        <a href="#" id="popup-closer" class="ol-popup-closer"></a>
        <div id="popup-content"></div>
    </div>
    <table class="legend_table">
      <tbody>
        <tr class="legend_row">
          <td class="legend_cell"><div class="legend_color" style="border: none;border-radius: 10px;margin-right: 5px;" :style="{ 'background-color' : legendColor }" ></div><div class="legend_label">{{ getTranslation(legendName) }}</div></td>
        </tr>        
      </tbody>
    </table>

  </v-container>
</template>

<script>
  import 'ol/ol.css';
  import GeoJSON from 'ol/format/GeoJSON';
  import Map from 'ol/Map';
  import View from 'ol/View';
  import {fromLonLat/*, toLonLat*/} from 'ol/proj';
  import VectorSource from 'ol/source/Vector';
  import VectorLayer from 'ol/layer/Vector';
  import TileLayer from 'ol/layer/Tile';
  import { Fill, Stroke, Style, Text, Icon } from 'ol/style';
  import { defaults as defaultInteractions, MouseWheelZoom, DoubleClickZoom, DragPan } from 'ol/interaction';

  //import laosData from '@/assets/laoPDR.json';
  //import roadData from '@/assets/roads_osm.json';

  import Feature from 'ol/Feature';
  import Overlay from 'ol/Overlay';
  import Point from 'ol/geom/Point';
  import Circle from 'ol/geom/Circle';

  export default {
    name: 'MapComponent',
    props: {
      mapLayer: {
        type: Array
      },
      provinceCoordinate: {
        type: Array
      },
      circleValue: {
        type: Array
      },
      circleWidth: {
        type: Array
      },
      legendColor: {
        type: String
      },
      legendName: {
        type: String
      },
      mapType: {
        type: String
      },
    },
    data: () => ({
      map: {}
    }),
    watch: {
      legendName: function(newVal, oldVal) {
        console.log('newVal LENGENDNAME MapComponent', newVal);
        this.map.set('legend_name', newVal);
      },
      circleValue: function(newVal, oldVal) {

        //When the value changes, we need to remove the previous layer of icon
        let iconLayerName = this.map.getLayers().getArray().filter(layer => layer.get('name') === 'iconLayer');
        let circleLayerName = this.map.getLayers().getArray().filter(layer => layer.get('name') === 'circleLayer');
        for(var i=0; i < circleLayerName.length; i++){
          this.map.removeLayer(circleLayerName[i]);
        }
        this.map.removeLayer(iconLayerName[0]);

        this.addIconLayer();

      }
    },
    mounted: function() {

      console.log('****Mounted');

      this.createProvinceMap();
      this.createRoadMap();
      this.addIconLayer();

    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      getLegendColor(color){
        {
            return {'background-color':color};
        }
      },
      addIconLayer(){

        var transparentLayerSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.mapLayer[0].form),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        var transparentLayer = new VectorLayer({
          renderMode: 'image',
          source: transparentLayerSource,
          style: styleTransparentFunction
        });

        function styleTransparentFunction(feature, resolution) {

          return [
            new Style({
                fill: new Fill({
                  color: '#ff000000'
                }),
                stroke: new Stroke({
                  color: '#ff000000',
                  width: 1,
                })
              })
          ];

        }

        const iconSource = new VectorSource({
          features: [],
        });

        const iconLayer = new VectorLayer({
          source: iconSource,
        });

        //for(let i = 0; i < disasterLocation.length; i++){
        for(let i = 0; i < this.provinceCoordinate.length; i++){

          const iconFeature = new Feature({
            //geometry: new Point(disasterLocation[i]),
            geometry: new Point(this.provinceCoordinate[i]),
            name: 'Luang Prabang'
          });
          const iconStyle = new Style({
            text: new Text({
                   //text: disasterValue[i],
                   text: this.circleValue[i],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                   width: 2,
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconFeature.setStyle(iconStyle);
          iconFeature.setId(i);
          iconLayer.set('name', 'iconLayer');
          iconLayer.getSource().addFeature(iconFeature);

        }

        this.map.addLayer(iconLayer);

        //for(let i = 0; i < disasterLocation.length; i++){
        for(let i = 0; i < this.provinceCoordinate.length; i++){
          const circleLayer = new VectorLayer({
            source: new VectorSource({
              //features: [new Feature(new Circle(disasterLocation[i],disasterWidth[i]))]
              features: [new Feature(new Circle(this.provinceCoordinate[i],this.circleWidth[i]))]
            }),
            style: [
                    new Style({
                      stroke: new Stroke({
                        color: this.legendColor,
                        width: 1
                      }),
                      fill: new Fill({
                        color: this.legendColor
                      })
                    })
                  ]
          }); 
          circleLayer.set('name', 'circleLayer');
          this.map.addLayer(circleLayer);
        }

        this.map.addLayer(transparentLayer);

      },
      createProvinceMap(){

        console.log('****createProvinceMap');
      /**
       * Elements that make up the popup.
       */
      const container = document.getElementById('popup');
      const content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');

      /**
       * Create an overlay to anchor the popup to the map.
       */
      const overlay = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });

      /**
       * Add a click handler to hide the popup.
       * @return {boolean} Don't follow the href.
       */
      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };

      /***************** Province *******************************/
      const laosIndex = this.mapLayer.findIndex(layer => layer.name === 'Laos');
      if(laosIndex !== -1){
        var laosSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.mapLayer[laosIndex].form),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        var laosLayer = new VectorLayer({
          renderMode: 'image',
          source: laosSource,
          style: styleLaosFunction
        });

        var defaultStyleLaos = new Style({
          fill: new Fill({
            color: this.mapLayer[laosIndex].fill_color,
          }),
          stroke: new Stroke({
            color: this.mapLayer[laosIndex].stroke_color,
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleLaosFunction(feature, resolution) {
              return [defaultStyleLaos];
        }

      }

      var view = new View({
        center: fromLonLat([0.0009340, 0.000156]),
        zoom: 23.5
      });

      /***************** Map *******************************/
      this.map = new Map({
        //name: 'assetMap',
        target: this.mapType,
        layers: [
          //laosLayer,
          //roadLayer
        ],
        overlays: [overlay],
        view: view
      });

      this.map.set('legend_name', this.legendName);

      if(laosIndex !== -1){
        this.map.addLayer(laosLayer);
      }

      const marker = new Overlay({
        position: fromLonLat([0.000924, 0.0001795]),
        positioning: 'center',
        element: document.getElementById('marker'),
        stopEvent: false,
      });

      this.map.addOverlay(marker);

      /**
       * Add a click handler to the map to render the popup.
       */
      this.map.on('singleclick', function (evt) {
        const coordinate = evt.coordinate;

        const pixel = evt.pixel;

        const feature = this.forEachFeatureAtPixel(pixel, function(feature) {
          return feature;
        });
        /*if (feature) {
          if (feature.get('name_en') !== undefined) {
            console.log("feature.get('name_en')");
            console.log(feature.get('name_en'));
          }
        }*/

        //console.log('*****this.mapType');
        console.log(this.values_);
        //console.log(this.values_.target);
        //console.log(this.values_.name);

        if(this.values_.target === 'DisasterMap'){

          if(feature.get('name_en') === 'VIENTIANE CAPITAL'){
              content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
              content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
              content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Cyclone (1 time)</span></p>';
              content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 40,000 mLAK</span></p>';
              content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 9,000</span></p>';
              content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 5,000</span></p>';
              content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 12,000</span></p>';
              content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 10,492</span></p>';
          }else if(feature.get('name_en') === 'P. LOUANGNAMTHA'){
              content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
              content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
              content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Storm (1 time)</span></p>';
              content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 50,000 mLAK</span></p>';
              content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 8,000</span></p>';
              content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 4,000</span></p>';
              content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 15,000</span></p>';
              content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 1,862</span></p>';
          }else if(feature.get('name_en') === 'P. ATTAPU'){
              content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
              content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
              content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Flash Flood (1 time)</span></p>';
              content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 30,000.15 mLAK</span></p>';
              content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 4,000</span></p>';
              content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 3,000</span></p>';
              content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 1,000</span></p>';
              content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 1,045</span></p>';
          }else{
              content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
              content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> /</span></p>';
              content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> /</span></p>';
              content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> /</span></p>';
              content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> /</span></p>';
              content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> /</span></p>';
              content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> /</span></p>';
              content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> /</span></p>';
          }



        //TO COMPLETE
        }else if(this.values_.target === 'AssetMap'){

              if(this.values_.legend_name === 'Bridge'){
                if(feature.get('name_en') === 'P. SAVANNAKHET'){
                    content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
                    content.innerHTML += '<p>Bridge Affected:<span style="font-weight:bold;"> 1</span></p>';
                    content.innerHTML += '<p>Name:<span style="font-weight:bold;"> Friendship Bridge</span></p>';
                    content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> Tropical Cyclone Dianmu</span></p>';
                }else{
                    content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
                    content.innerHTML += '<p>Bridge Affected:<span style="font-weight:bold;"> /</span></p>';
                    content.innerHTML += '<p>Name:<span style="font-weight:bold;"> /</span></p>';
                    content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> /</span></p>';
                }
              }else{
                if(feature.get('name_en') === 'P. SAVANNAKHET'){
                    content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
                    content.innerHTML += '<p>School Affected:<span style="font-weight:bold;"> 1</span></p>';
                    content.innerHTML += '<p>Name:<span style="font-weight:bold;"> Savannakhet University</span></p>';
                    content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> Tropical Cyclone Dianmu</span></p>';
                }else{
                    content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
                    content.innerHTML += '<p>School Affected:<span style="font-weight:bold;"> /</span></p>';
                    content.innerHTML += '<p>Name:<span style="font-weight:bold;"> /</span></p>';
                    content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> /</span></p>';
                }
              }

        }else{//Dashboard Case

          console.log('Dahsboard Map');
          if(this.values_.legend_name == 'Number of Disaster Per Province'){
            console.log('Dahsboard Map - Disaster');
            content.innerHTML =  '<p>Province Disaster:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          }else if(this.values_.legend_name == 'Number of Project Per Province'){
            console.log('Dahsboard Map - Project');
            content.innerHTML =  '<p>Province Project:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          }else{
            console.log('Dahsboard Map - Asset');
            content.innerHTML =  '<p>Province Asset:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          } 
          /*if(feature.get('name_en') === 'P. SAVANNAKHET'){
                    content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
                    content.innerHTML += '<p>Project:<span style="font-weight:bold;"> 1</span></p>';
                    content.innerHTML += '<p>Name:<span style="font-weight:bold;"> Friendship Bridge</span></p>';
                    content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> Tropical Cyclone Dianmu</span></p>';
                }else{
                    content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
                    content.innerHTML += '<p>Project:<span style="font-weight:bold;"> /</span></p>';
                    content.innerHTML += '<p>Name:<span style="font-weight:bold;"> /</span></p>';
                    content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> /</span></p>';
                }*/

        }

        overlay.setPosition(coordinate);

      });

    },
    createRoadMap(){

      /***************** Road *******************************/
      const roadIndex = this.mapLayer.findIndex(layer => layer.name === 'Road');
      if(roadIndex !== -1){
        var roadSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.mapLayer[roadIndex].form),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        var roadLayer = new VectorLayer({
          renderMode: 'image',
          source: roadSource,
          style: styleRoadFunction
        });

        var defaultStyleRoad = new Style({
          fill: new Fill({
            color: this.mapLayer[roadIndex].fill_color,
          }),
          stroke: new Stroke({
            color: this.mapLayer[roadIndex].stroke_color,
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleRoadFunction(feature, resolution) {
              return [defaultStyleRoad];
        }

      }

      if(roadIndex !== -1){
        this.map.addLayer(roadLayer);
      }

    }


  }

}
</script>

<style>
  .row {
    margin: 0px;
  }
  .pd-0 {
    padding: 7px;
  }
  .v-application p {
      margin-bottom: 5px;
      font-size: 13px;
  }
  #information {
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    font-size: 10px;
    color: #212121;
    z-index: 100;
    position: relative;
    padding: 5px;
  }

  #marker {
    width: 20px;
    height: 20px;
    opacity: 1;
  }

  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 310px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }

</style>
